import * as React from 'react';
import { useSlate } from 'slate-react';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { DisplayTextProps } from '@sdk/components/ui/DisplayTextStyle';
import View from '@sdk/components/primitives/View';
import DisplayText from '@sdk/components/ui/DisplayText';

import { toggleMark, isMarkActive } from '../helpers/utils';
import { CustomMarkTypes } from '../types';

import TextEditToolbarButton from './TextEditToolbarButton';

type Props = {
  format: CustomMarkTypes;
} & DisplayTextProps;

const MarkButton: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  format,
  ...restProps
}) => {
  const editor = useSlate();
  const isActive = isMarkActive(editor, format);
  const themeColor = isActive ? ThemeColorType.white : ThemeColorType.iconGray;

  return (
    <View>
      <TextEditToolbarButton
        isActive={isActive}
        onMouseDown={(e: React.SyntheticEvent): void => {
          e.preventDefault();
          toggleMark(editor, format);
        }}
        mRight={3}>
        <DisplayText fontSize={14} themeColor={themeColor} {...restProps}>
          {children}
        </DisplayText>
      </TextEditToolbarButton>
    </View>
  );
};

export default MarkButton;
